import { EmployeesService, IEmployee, IShift, ShiftService } from '../../services';
import * as moment from 'moment';

class ShiftListEmployeeController implements ng.IComponentController {
    private selectedEmployee: any;
    private employees: any;
    private onChange: any;
    private shift: IShift;

    constructor(
        private ShiftService: ShiftService, private EmployeesService: EmployeesService
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.onChange({type: 'open', data: this.shift});
        this.getEmployees();
    }    

    public $onDestroy = () => {
        this.onChange({type: 'close', data: this.shift});
    }

    private getEmployees = () =>  {
        var request = {
            accountId: this.shift.teamLocationAccountId,
            locationId: this.shift.teamLocationId,
            startDate: this.shift.start,
            endDate: this.shift.end,
            shiftId: this.shift.id
        };

        this.EmployeesService.customPost('availableEmployees', request, false).then((result: any) => {
            this.employees = result;
            this.selectedEmployee = this.employees.find(employeeSummary => employeeSummary.employee.id == this.shift.employeeId);
        });
    }

    private unassignEmployee = () => {
        this.shift.employeeId = null;
        this.shift.status = 2;
        this.selectedEmployee = null;
        this.submitShift();
    }

    private submitShift() {
        this.shift.start = moment(this.shift.start).format("YYYY-MM-DD HH:mm");
        this.shift.end = moment(this.shift.end).format("YYYY-MM-DD HH:mm");
        if (this.shift.employeeId !== null) {
            this.shift.status = 6;
        }
        this.ShiftService.put(this.shift.id, this.shift).then((data) => {
            this.onChange({type: 'updated', data: data});
            this.getEmployees();
        });
    }
}

export const shiftListEmployeeComponent: ng.IComponentOptions = {
    bindings: {
        shift: '<',
        //employees: '<',
        functions: '<',
        onChange: '&',
    },
    controller: ShiftListEmployeeController,
    template: <string>require('./shift.list.employee.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/shifts/shift.list.employee.component.ts